import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private baseUrl = environment.baseUrl;

  constructor(
    private httpClient: HttpClient
  ) { }

  getNotifications(filters?: any) {
    let params = new HttpParams();

    if (filters && filters.search) {
      params = params.append('search', filters.search)
    }

    if (filters && filters.page) {
      params = params.append('page', filters.page)
    }

    if (filters && filters.page_size) {
      params = params.append('page_size', filters.page_size)
    }

    return this.httpClient.get<any>(`${this.baseUrl}/notifications`, {
      params
    });
  }

  markAsRead(notificationId: string) {
    console.log(notificationId);
    return this.httpClient.patch<any>(`${this.baseUrl}/notifications/${notificationId}/`, {
      read: true
    });
  }
}
